export let mockEmail = {
  id: null,
  purpose: null,
  email: null,
  default: null,
  active: true
}
